import React, { useEffect, useState } from 'react';
import { Message } from 'react-frontier2';
import { useTranslation } from 'react-i18next';

interface NoAccessMessageProps{
	
}

var NoAccessMessage = (props: NoAccessMessageProps)=>{
	var { t } = useTranslation();
	useEffect(()=>{
		
	}, []);
	
	return <Message type='warning' centered style={{ maxWidth: 400, margin: 'auto' }} header={t('common.no_access')}>
		{t('common.no_access_action')}
	</Message>
}

export default NoAccessMessage;